module.exports = __webpack_public_path__ + "images/1315e976821c4b11c9a643992ae8e753.png";